import styled from 'styled-components';
import * as BuilderInfoUI from '../../BuilderInfoUI';
import { borderedContent } from '../../../../styles/shareableStyles';

export const CohortDetailsContent = styled(BuilderInfoUI.BorderedSectionHeader)`
  ${borderedContent};
  background-color: unset;
`;

export const CohortDetailsBorderedInfo = styled(BuilderInfoUI.BorderedInfo)`
  min-width: unset;
  margin-right: 0;
`;
